import * as React from 'react';
import { CtaButton, EyeIcon, P, rem, Spacer, theme } from 'design-system';
import { useRouter } from 'next/router';

import { Section, SectionInner } from '../components/section';
import { Journal } from '../resources/journal';

export const SampleDocumentBanner = ({
  publisherId,
  journalId,
}: {
  publisherId: Journal['publisher']['slug'];
  journalId: Journal['slug'];
}) => {
  const router = useRouter();

  return (
    <Section css={{ backgroundColor: theme.colors.blue3 }}>
      <Spacer height={12} />
      <SectionInner
        css={{ display: 'flex', gap: rem(24), justifyContent: 'space-between' }}
      >
        <P
          size="medium"
          css={{
            color: theme.colors.blue11,
            fontWeight: theme.fontWeights.medium,
            display: 'flex',
            gap: rem(12),
            alignItems: 'center',
          }}
        >
          <EyeIcon width={rem(21)} />
          You’re viewing a sample Preflight result
        </P>
        <CtaButton
          onClick={() => {
            router.push(`/partner/${publisherId}/${journalId}`);
          }}
        >
          Check your own manuscript now
        </CtaButton>
      </SectionInner>
      <Spacer height={12} />
    </Section>
  );
};
